import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../../config/AuthContext";
import { useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "./Login";
import { Button, Card, DatePicker, Form, Input, Modal, Select, Table, Upload, TableProps, Popconfirm, Spin, Tag } from 'antd';
import Colors from "../../styles/Colors";
import { BiRefresh, BiUpload, BiCloudUpload } from "react-icons/bi";
import Historials from "../components/Historials";
import CompteActTable from "../components/CompteActTable";
import { ColumnsType } from "antd/es/table";
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import toast, { Toaster } from "react-hot-toast";

const apiUrl = process.env.REACT_APP_API_URL;

const FacturacioHolded = () => {
    const titol: string = "FACTURACIÓ HOLDED";
    const nomPermis: string = "FACTURACIÓ HOLDED";

    const { isLoggedIn, user, page } = useContext(AuthContext);
    const navigate = useNavigate();

    const [coleccio, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);
    const [isConfigModalVisible, setIsConfigModalVisible] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editingRow, setEditingRow] = useState<any>(null);
    const [form] = Form.useForm();
    const [editForm] = Form.useForm();

    const permisosEdicio = user.pagines.some((pagina: any) =>
        pagina.descripcio && pagina.descripcio.toUpperCase() === nomPermis.toUpperCase() && pagina.tipus === 1
    );

    useEffect(() => {
        console.log("Permisos de l'usuari per a aquesta pàgina:", permisosEdicio, user.pagines);
        if (isLoggedIn) {
            checkDades();
        }
    }, []);

    async function checkDades() {
        setLoading(true);
        try {
            const response = await fetch(`${apiUrl}:8071/api/facturacio/list`, {
                headers: {
                    'pantalla': window.location.href,
                    'idusuari': user.id.toString()
                }
            });
            if (response.ok) {
                const data = await response.json();
                setDades(data);
            }
        } catch (e) {
            console.error("Error fetching list", e);
        }
        setLoading(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'idrebu',
            title: 'ID Rebut',
            dataIndex: 'idrebu',
            // Default filter search (basic string include)
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Buscar ID"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button type="primary" onClick={() => confirm()} size="small" style={{ width: 90, marginRight: 8 }}>Buscar</Button>
                    <Button onClick={() => clearFilters && clearFilters()} size="small" style={{ width: 90 }}>Netejar</Button>
                </div>
            ),
            onFilter: (value, record) => record.idrebu.toString().toLowerCase().includes((value as string).toLowerCase()),
        },
        {
            key: 'data_fact',
            title: 'Data Fact.',
            dataIndex: 'data_fact',
            sorter: (a, b) => a.data_fact.localeCompare(b.data_fact),
        },
        {
            key: 'societat',
            title: 'Societat',
            dataIndex: 'societat',
            filters: Array.from(new Set(coleccio.map(item => item.societat))).map(soc => ({ text: soc, value: soc })),
            onFilter: (value, record) => record.societat === value,
        },
        {
            key: 'import_rebut',
            title: 'Import',
            dataIndex: 'import_rebut',
            render: (text) => `${text} €`,
            sorter: (a, b) => a.import_rebut - b.import_rebut,
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            filters: [
                { text: 'PENDENT', value: 'PENDENT' },
                { text: 'ERROR', value: 'ERROR' },
                { text: 'COMPLETAT', value: 'COMPLETAT' }
            ],
            defaultFilteredValue: ['PENDENT', 'ERROR'],
            onFilter: (value, record) => record.estat === value,
            render: (estat) => (
                <Tag color={estat === 'ERROR' ? 'red' : estat === 'COMPLETAT' ? 'green' : 'orange'}>
                    {estat}
                </Tag>
            )
        },
        {
            key: 'actions',
            title: 'Accions',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    {record.estat === 'ERROR' && (
                        <Button size="small" type="primary" onClick={() => {
                            setEditingRow(record);
                            editForm.setFieldsValue({
                                compte: record.compte,
                                idact_holded: record.idact_holded
                            });
                            setEditModalVisible(true);
                        }}>Editar</Button>
                    )}
                    {(record.estat === 'PENDENT' || record.estat === 'ERROR') && (
                        <Popconfirm
                            title="Eliminar rebut"
                            description="N'estàs segur d'eliminar aquest rebut?"
                            onConfirm={() => handleDeleteRows([record.id])}
                            okText="Sí"
                            cancelText="No"
                        >
                            <Button size="small" danger icon={<DeleteOutlined />} title="Eliminar" />
                        </Popconfirm>
                    )}
                </div>
            )
        }
    ];

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record: any) => ({
            disabled: record.estat !== 'PENDENT', // Només es poden enviar els pendents
            name: record.idrebu,
        }),
    };

    const tableProps: TableProps<any> = {
        loading,
        rowSelection,
        rowKey: 'id',
    };

    const uploadProps = {
        name: 'file',
        action: '#', // We will replace with real API soon
        customRequest: async (options: any) => {
            const { file, onSuccess, onError } = options;
            const formData = new FormData();
            formData.append("file", file);

            try {
                setLoading(true);
                const response = await fetch(`${apiUrl}:8071/api/facturacio/upload-xml`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'pantalla': window.location.href,
                        'idusuari': user.id.toString()
                    }
                });
                const result = await response.json();

                if (response.ok) {
                    onSuccess("Ok");

                    const hasSenseCompte = result.senseCompte && result.senseCompte.length > 0;
                    const hasDuplicats = result.duplicats && result.duplicats.length > 0;

                    if (hasSenseCompte || hasDuplicats) {
                        Modal.warning({
                            title: 'Atenció: S\'han trobat avisos en l\'arxiu',
                            width: 600,
                            content: (
                                <div>
                                    <p>L'arxiu s'ha llegit i processat, però hi ha els següents avisos:</p>

                                    {hasSenseCompte && (
                                        <>
                                            <p style={{ color: 'red', fontWeight: 'bold', marginTop: '10px' }}>
                                                {result.senseCompte.length} rebut(s) inserits amb estat ERROR (sense compte):
                                            </p>
                                            <div style={{ maxHeight: '150px', overflowY: 'auto', background: '#ffe6e6', padding: '10px', borderRadius: '5px' }}>
                                                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                                    {result.senseCompte.map((w: string, i: number) => <li key={i} style={{ fontSize: '12px' }}>{w}</li>)}
                                                </ul>
                                            </div>
                                        </>
                                    )}

                                    {hasDuplicats && (
                                        <>
                                            <p style={{ color: 'orange', fontWeight: 'bold', marginTop: '10px' }}>
                                                {result.duplicats.length} rebut(s) duplicats ignorats (ja estaven a la BD):
                                            </p>
                                            <div style={{ maxHeight: '150px', overflowY: 'auto', background: '#fff4e6', padding: '10px', borderRadius: '5px' }}>
                                                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                                    {result.duplicats.map((w: string, i: number) => <li key={i} style={{ fontSize: '12px' }}>{w}</li>)}
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )
                        });
                    } else {
                        toast.success("Fitxer XML pujat i processat correctament.");
                    }

                    checkDades();
                } else {
                    throw new Error(result.message || "Error");
                }
            } catch (error: any) {
                onError(error);
                toast.error(error.message || "Error al pujar o processar el fitxer XML.");
            } finally {
                setLoading(false);
            }
        },
        showUploadList: false,
    };

    function openConfigModal() {
        form.setFieldsValue({
            docType: 'invoice',
            contactStrategy: 'name',
            taxes: 0,
            defaultAccount: ''
        });
        setIsConfigModalVisible(true);
    }

    async function syncHolded(values: any) {
        values.selectedIds = selectedRowKeys;
        setIsConfigModalVisible(false);
        setLoading(true);
        try {
            const response = await fetch(`${apiUrl}:8071/api/facturacio/sync-holded`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'pantalla': window.location.href,
                    'idusuari': user.id.toString()
                },
                body: JSON.stringify(values)
            });
            if (response.ok) {
                toast.success("Assentaments enviats a Holded correctament.");
                checkDades();
            } else {
                toast.error("Error en sincronitzar amb Holded.");
            }
        } catch (e) {
            toast.error("Error en sincronitzar amb Holded.");
        }
        setLoading(false);
    }

    async function handleDeleteRows(ids: React.Key[]) {
        setLoading(true);
        try {
            const response = await fetch(`${apiUrl}:8071/api/facturacio/delete-rows`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'pantalla': window.location.href,
                    'idusuari': user.id.toString()
                },
                body: JSON.stringify({ ids })
            });
            if (response.ok) {
                toast.success("Rebuts eliminats correctament.");
                setSelectedRowKeys([]);
                checkDades();
            } else {
                toast.error("Error al eliminar els rebuts.");
            }
        } catch (e) {
            toast.error("Error al eliminar els rebuts.");
        }
        setLoading(false);
    }

    async function handleUpdateRow(values: any) {
        setLoading(true);
        try {
            const response = await fetch(`${apiUrl}:8071/api/facturacio/update-row`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'pantalla': window.location.href,
                    'idusuari': user.id.toString()
                },
                body: JSON.stringify({
                    id: editingRow.id,
                    compte: values.compte,
                    idact_holded: values.idact_holded
                })
            });
            if (response.ok) {
                toast.success("Fila actualitzada correctament.");
                setEditModalVisible(false);
                checkDades();
            } else {
                toast.error("Error al actualitzar la fila.");
            }
        } catch (e) {
            toast.error("Error al actualitzar la fila.");
        }
        setLoading(false);
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster />
                <NavBar />
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <>
                                    <Upload {...uploadProps}>
                                        <Button style={{ backgroundColor: Colors.colors.color2 }} icon={<UploadOutlined />} title={"Pujar XML LOOP"}>
                                            Importar XML LOOP
                                        </Button>
                                    </Upload>
                                    <Button style={{ backgroundColor: Colors.colors.color6, marginLeft: '10px' }} onClick={openConfigModal} title={"Sincronitzar amb Holded"} disabled={selectedRowKeys.length === 0}>
                                        <BiCloudUpload /> Enviar a Holded ({selectedRowKeys.length})
                                    </Button>
                                    <Popconfirm
                                        title="Eliminar rebuts"
                                        description={`N'estàs segur d'eliminar els ${selectedRowKeys.length} rebuts seleccionats? (Només s'eliminaran els PENDENT o ERROR)`}
                                        onConfirm={() => handleDeleteRows(selectedRowKeys)}
                                        okText="Sí"
                                        cancelText="No"
                                        disabled={selectedRowKeys.length === 0}
                                    >
                                        <Button danger style={{ marginLeft: '10px' }} icon={<DeleteOutlined />} disabled={selectedRowKeys.length === 0}>
                                            Eliminar ({selectedRowKeys.length})
                                        </Button>
                                    </Popconfirm>
                                </>
                            }
                            <Button title={"Refrescar"} style={{ backgroundColor: Colors.colors.color4, marginLeft: '10px' }} onClick={() =>
                                checkDades()}><BiRefresh /></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                rowSelection={rowSelection}
                                columns={columns}
                                dataSource={coleccio}
                                rowKey="id"
                                loading={loading}
                                size="middle"
                                pagination={{ pageSize: 100 }}
                            />
                        )}
                    </Card>
                    <Modal
                        title="Configuració de l'Enviament a Holded"
                        open={isConfigModalVisible}
                        onCancel={() => setIsConfigModalVisible(false)}
                        onOk={() => form.submit()}
                        okText="Confirmar Enviament"
                        cancelText="Cancel·lar"
                        maskClosable={false}
                    >
                        <Form layout="vertical" form={form} onFinish={syncHolded}>
                            <Form.Item label="Tipus de Document" name="docType" rules={[{ required: true }]}>
                                <Select>
                                    <Select.Option value="invoice">Factura de Venda</Select.Option>
                                    <Select.Option value="salesreceipt">Tiquet / Rebut de Venda</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="Mapeig de Contactes" name="contactStrategy" rules={[{ required: true }]}>
                                <Select>
                                    <Select.Option value="name">Crear o vincular pel Nom (Societat)</Select.Option>
                                    <Select.Option value="nif">Buscar prèviament pel NIF (si en tenim)</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="IVA a aplicar (%)" name="taxes" rules={[{ required: true }]}>
                                <Select>
                                    <Select.Option value={0}>0% (Exempt)</Select.Option>
                                    <Select.Option value={4}>4% (Superreduït)</Select.Option>
                                    <Select.Option value={10}>10% (Reduït)</Select.Option>
                                    <Select.Option value={21}>21% (General)</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="Compte Comptable per defecte (Opcional)" name="defaultAccount">
                                <Input placeholder="Ex: 70000000" />
                            </Form.Item>
                        </Form>
                    </Modal>

                    <Modal
                        title="Editar fila amb Error"
                        open={editModalVisible}
                        onCancel={() => setEditModalVisible(false)}
                        onOk={() => editForm.submit()}
                        okText="Actualitzar"
                        cancelText="Cancel·lar"
                    >
                        <Form layout="vertical" form={editForm} onFinish={handleUpdateRow}>
                            <p>Corregir els camps per a la fila amb ID intern: <b>{editingRow?.id}</b> (Rebut: <b>{editingRow?.idrebu}</b>)</p>
                            <Form.Item label="Compte Contable" name="compte" rules={[{ required: true }]}>
                                <Input placeholder="Ex: 7000000" />
                            </Form.Item>
                            <Form.Item label="ID Activitat Holded" name="idact_holded" rules={[{ required: true }]}>
                                <Input placeholder="Ex: 60a12b..." />
                            </Form.Item>
                        </Form>
                    </Modal>

                    <br />
                    <CompteActTable />
                    <br />
                    <Historials pantalla={titol} pagina={page} />
                </div>
            </div>
        );
    } else {
        return (
            <Login />
        );
    }
};

export default FacturacioHolded;
